import { render, staticRenderFns } from "./demographicsEditor.vue?vue&type=template&id=095a0f5d&scoped=true&lang=html&"
import script from "./demographicsEditor.vue?vue&type=script&lang=js&"
export * from "./demographicsEditor.vue?vue&type=script&lang=js&"
import style0 from "./demographicsEditor.vue?vue&type=style&index=0&id=095a0f5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095a0f5d",
  null
  
)

export default component.exports